import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCreditCardRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16 5.5q.5 0 .5.5v1h-13V6q0-.5.5-.5zm.5 3.5v5q0 .5-.5.5H4l-.5-.5V9zM4 4a2 2 0 0 0-2 2v8q.2 1.8 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm.5 8.8q0 .6.8.7h1.5q.7 0 .7-.7a1 1 0 0 0-.7-.8H5.3a1 1 0 0 0-.8.8m4.5 0q0 .6.8.7h2q.6 0 .7-.7a1 1 0 0 0-.7-.8h-2a1 1 0 0 0-.8.8" })
});
export default SvgCreditCardRegularIcon;
